import React, { useState, useEffect, useRef } from 'react';

import CurrencyInput from 'react-currency-input-field';
import Modal from 'react-modal';

const AddInsuranceModal = ({ showModal, setShowModal, handleSave, insurance, isEdit }) => {
  const fields = ['provider', 'policyNumber', 'coverageAmount', 'expirationDate'];
  const [data, setData] = useState({
    provider: '',
    policyNumber: '',
    coverageAmount: '',
    expirationDate: '',
  });
  const [dataError, setDataError] = useState({});

  useEffect(() => {
    if (insurance) {
      setData(insurance);
    }
  }, [insurance]);

  const handleCloseModal = () => {
    setShowModal(false);
    setData({});
  };

  const handleSubmit = () => {
    let hasError = false;
    setDataError({});
    fields.map((key) => {
      if (!data[key]) {
        hasError = true;
        setDataError({
          ...dataError,
          [key]: 'The field is required',
        });
      }
    });

    if (hasError) {
      return false;
    }

    handleSave(data);
    handleCloseModal();
  };

  const handleChange = (e, name) => {
    setData({
      ...data,
      [name]: e.target.value,
    });
  };
  const handleCurrenyChange = (value, name) => {
    if (value > 1000000000) {
      let fixedValue = '';
      if (value.includes('.')) {
        const arrNumberStr = value.split('.');
        fixedValue =
          arrNumberStr[0].substring(0, arrNumberStr[0].length - 1) + '.' + arrNumberStr[1];
      } else {
        fixedValue = value.substring(0, value.length - 1);
      }

      setData({
        ...data,
        [name]: fixedValue,
      });
      return false;
    }
    setData({ ...data, [name]: value });
  };

  return (
    <Modal isOpen={showModal} className="insurance-modal field-modal">
      <div>
        <span className="close" onClick={() => handleCloseModal()}>
          x
        </span>
        <div className="modal-header">{isEdit ? 'Edit' : 'Add'} Insurance</div>
        <div className="modal-content form-part">
          <div className="form-list">
            <div className={`form-group ${dataError['provider'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="provider">
                  Insurance Provider
                  {/* <span className="required">*</span> */}
                </label>
                <input
                  id="provider"
                  onChange={(e) => handleChange(e, 'provider')}
                  value={data['provider']}
                  name="provider"
                  className={dataError['provider'] ? 'error' : ''}
                  placeholder="Provider"
                />

                {dataError['provider'] && <p className="error-text">{dataError['provider']}</p>}
              </div>
            </div>
            <div className={`form-group ${dataError['policyNumber'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="policyNumber">
                  Policy Number
                  {/* <span className="required">*</span> */}
                </label>
                <input
                  id="policyNumber"
                  value={data['policyNumber']}
                  name="policyNumber"
                  onChange={(e) => handleChange(e, 'policyNumber')}
                  className={dataError['policyNumber'] ? 'error' : ''}
                  placeholder="Policy Number"
                  spellCheck={false}
                />
                {dataError['policyNumber'] && (
                  <p className="error-text">{dataError['policyNumber']}</p>
                )}
              </div>
            </div>
            <div className={`form-group ${dataError['coverageAmount'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="coverageAmount">
                  Coverage Amount
                  {/* <span className="required">*</span> */}
                </label>
                <CurrencyInput
                  id="coverageAmount"
                  name="coverageAmount"
                  placeholder="Coverage Amount"
                  value={data['coverageAmount']}
                  decimalScale={2}
                  onValueChange={(value, name) => handleCurrenyChange(value, 'coverageAmount')}
                  className={dataError['coverageAmount'] ? 'error' : ''}
                  intlConfig={{ locale: 'en-US', currency: 'USD' }}
                  spellCheck={false}
                />
                {dataError['coverageAmount'] && (
                  <p className="error-text">{dataError['coverageAmount']}</p>
                )}
              </div>
            </div>
            <div className={`form-group ${dataError['expirationDate'] ? 'error' : ''}`}>
              <div className="form-field">
                <label htmlFor="expirationDate">
                  Expiration Date
                  <span className="required">*</span>
                </label>
                <input
                  id="expirationDate"
                  value={data['expirationDate']}
                  name="expirationDate"
                  type="date"
                  onChange={(e) => handleChange(e, 'expirationDate')}
                  className={dataError['expirationDate'] ? 'error' : ''}
                  placeholder="Expiration Date"
                  max="2199-12-12"
                  spellCheck={false}
                />
                {dataError['expirationDate'] && (
                  <p className="error-text">{dataError['expirationDate']}</p>
                )}
              </div>
            </div>
          </div>
          <div className="action-button">
            <button type="button float-right" onClick={handleSubmit}>
              {isEdit ? 'Update' : 'Create'} insurance
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddInsuranceModal;
